import { RouteRecordRaw } from "vue-router";
import { userMustBeLoggedIn, userMustHaveApproval } from "../../router/guards";

const routes: RouteRecordRaw[] = [
    {
        path: '/my-advertisement',
        name: 'my-advertisement',
        redirect: { name: 'my-advertisement-listing' },
        component: () => import('./my-advertisement-page.vue'),
        beforeEnter: [userMustBeLoggedIn, userMustHaveApproval],
        children: [
            {
                name: 'my-advertisement-listing',
                path: 'listing',
                component: () => import('./my-advertisement-listing-page.vue'),
                beforeEnter: [userMustBeLoggedIn],
            },
            {
                name: 'advertisement-details',
                path: ':advertisementId/details',
                component: () => import('./my-advertisement-detail-page.vue'),
                beforeEnter: [userMustBeLoggedIn],
                props: true,
                children: [
                    {
                        name: 'advertisement-details-update',
                        path: 'update',
                        component: () => import('./my-advertisement-update-form.vue'),
                        beforeEnter: [userMustBeLoggedIn]
                    }
                ]
            }
        ]
    }
]

export default routes;